export default __webpack_public_path__ + "static/media/union.7855db91.svg";